// extracted by mini-css-extract-plugin
export var completionBody = "_d3-2";
export var completionCard = "_d3-0";
export var completionFooter = "_d3-3";
export var completionTitle = "_d3-1";